import { motion } from 'motion/react';
import styled from 'styled-components';

export const NavigationRangeStyles = styled.div`
  body.dark & {
    --onboarding-navigation-item-color: #bd18b1;
  }

  --onboarding-navigation-item-color: #000;
  --onboarding-navogation-dot-size: 5px;
  padding: 24px 24px 8px;
  z-index: 1;
  width: 100%;
`;

export const NavigationBackButtonStyles = styled.button`
  body.dark & {
    color: #fff;
  }

  position: absolute;
  left: 0;
  top: 0;
  font-size: 24px;
  line-height: 0;
  color: #000;
  background-color: unset;
  border: none;
  outline: none;
`;

export const NavigationProgressStyles = styled.div`
  width: 100%;
  height: 4px;
  max-width: 200px;
  margin: 0 auto;
  position: relative;
  background: #78788029;
  border-radius: 8px;
`;

export const NavigationProgressBarStyles = styled(motion.div)`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  background: #bd18b1;
  border-radius: 8px;
`;
